<template>
  <!-- Same bootstrap custom-checkbox as Generate Invoices' tables
       (BaseCheckbox), styled the same way. -->
  <div class="isc-checkbox base-checkbox" @click.stop>
    <b-form-checkbox
      :key="renderKey"
      :checked="checked"
      :indeterminate="indeterminate"
      :disabled="disabled"
      :aria-label="ariaLabel"
      @change="handleChange"
    />
  </div>
</template>

<script>
// Fully controlled by its props. b-form-checkbox keeps its own local
// checked state, which drifts when a click should leave the state
// unchanged (e.g. a partly-checked header clicked to clear the selection
// flips the box, but the bound value itself never changes, so nothing
// resets it). Remounting after every change makes it re-read the props.
import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'InvoicingSelectCheckbox',
  props: {
    checked: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    ariaLabel: { type: String, default: 'Select row' },
  },
  emits: ['toggle'],
  setup(props, { emit }) {
    const renderKey = ref(0)

    const handleChange = () => {
      emit('toggle')
      renderKey.value += 1
    }

    return { renderKey, handleChange }
  },
})
</script>

<style scoped>
.isc-checkbox { display: inline-flex; align-items: center; }
.isc-checkbox >>> .custom-control {
  line-height: 1;
  margin: 0 !important;
  display: inline-flex;
  align-items: center;
}
.isc-checkbox >>> .custom-checkbox label {
  min-width: 20px;
  min-height: 20px;
  padding-left: 20px;
  margin-bottom: 0;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}
</style>
